// extracted by mini-css-extract-plugin
module.exports = {"ServiceWorkerWrapper":"ServiceWorkerWrapper_ServiceWorkerWrapper__1jczG","UpgradeNoticeBox":"ServiceWorkerWrapper_UpgradeNoticeBox__oLSuc"};